import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Constant from '@/configs/constant';
import './plugins';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locales/i18n';
import * as filters from './filters';
import * as helpers from '@/helpers';
import '@fontsource/noto-sans-jp';
import AuthorizationService from '@/services/authorizationService';

const authorizationService = new AuthorizationService();

Vue.config.productionTip = false;
Vue.prototype.$constant = Constant;
Vue.prototype.$helpers = helpers;
Vue.prototype.$fileUrl = process.env.VUE_APP_FILE_URL;
Vue.prototype.$authorizationService = authorizationService;
Object.keys(filters).forEach(key => { Vue.filter(key, filters[key]); });
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
